import BreadCrumbsAppo from "../../components/main/BreadcrumbsAppo";
import Collaps from "../../components/main/Collapse";
import Loader from "../../components/main/Loader";
import { useGetGlobalAppointmentsQuery } from "../../store/services/CalendarHoursService";
import HoursCalendar from "./AppointmentLimits";
import AppointmentLimits from "./GlobalInfo";

export default function MainCalendar() {

    const { data: globalAppointments, isLoading } = useGetGlobalAppointmentsQuery('');

    return (
        <div className="py-2">
            <BreadCrumbsAppo />
            <h2 className="text-xl py-6 mt-4">Gestisci il numero massimo di appuntamenti per sede</h2>
            {isLoading
                ? <Loader />
                : <div className="flex flex-col gap-6">

                    <Collaps 
                        title="Limiti globali" 
                        content={
                            <AppointmentLimits globalAppointments={globalAppointments.result} />
                        }
                    />

                    <Collaps 
                        title="Calendario" 
                        content={
                            <HoursCalendar globalAppointments={globalAppointments.result} />
                        } 
                    />
                </div>
            }
        </div>
    )
}